import { combineReducers } from 'redux';
import { ordermadeArrowModelReducer } from './OrdermadeArrowModelReducer';
import { APIDataGetReducer } from './APIDataGetReducer'; // TODO
import { partsSelectReducer } from './PartsSelectReducer';
import { yourDesignReducer } from './YourDesignReducer';
import { PriceSumReducer } from './PriceSumReducer'; // TODO

import { recommendDesignReducer } from './RecommendDesignReducer';
import { expressOrderReducer } from './ExpressOrderReducer';
import { shippingDateReducer } from './ShippingDateReducer';
import { defaultUnitReducer } from './DefaultUnitReducer';
import { availableOrderPartsReducer } from './availableOrderPartsReducer';

import { uiReducers } from './ui';

// received by ordermade controller
const reducerWithControllerState = {
    recommendDesign: recommendDesignReducer,
    expressOrder: expressOrderReducer,
    shippingDate: shippingDateReducer,
    defaultUnit: defaultUnitReducer,
    selectable_items: availableOrderPartsReducer,
};

export const rootReducer = combineReducers({
    ...uiReducers,
    ...reducerWithControllerState,
    model: ordermadeArrowModelReducer,
    customize: partsSelectReducer,
    APIData: APIDataGetReducer,
    yourDesign: yourDesignReducer,
    price: PriceSumReducer,
});

export type AppState = ReturnType<typeof rootReducer>;
